module.exports = __webpack_public_path__ + "img/notice.81b7535b.png";